import { window } from '../globals';

enum CustomEvents {
  COOKIE_POPUP_CLOSED = 'cookiePopupClosed',
}

const cookiePopupClosed = (): CustomEvent =>
  new CustomEvent(CustomEvents.COOKIE_POPUP_CLOSED);

const dispatchCustomEvent = (event: CustomEvent) => {
  if (window) {
    window.dispatchEvent(event);
  }
};

function onCustomEvent<Payload>(
  type: string,
  callback: (event: CustomEvent<Payload>) => void,
  args?: Parameters<Window['addEventListener']>[2],
): () => void {
  window?.addEventListener(type, callback as () => void, args);

  return () => window?.removeEventListener(type, callback as () => void, args);
}

export { dispatchCustomEvent, onCustomEvent, cookiePopupClosed, CustomEvents };
